import { MessageValidateRequiredObj } from "./message-types";

export class MessageValidate {
  // deprecated
  static required = (
    name: string,
    isObject?: boolean,
  ): string | MessageValidateRequiredObj => {
    const msg = `${name} harus diisi.`;

    return isObject ? { required_error: msg } : msg;
  };

  static requiredObj = (name: string): MessageValidateRequiredObj => {
    const msg = `${name} harus diisi.`;

    return { required_error: msg };
  };

  static digit = (
    name: string,
    length: number,
  ): [number, { message: string }] => [
    length,
    { message: `${name} harus diisi ${length.toFixed()} digit` },
  ];

  static requiredNumber = (name: string): string =>
    `${name} harus dalam format angka`;

  static maximumNumber = (name: string, max: number): string =>
    `Nilai maksimal dari ${name} adalah ${max}`;

  static minimumNumber = (name: string, min: number): string =>
    `Nilai minimum dari ${name} adalah ${min}`;

  static numbDigit = (name: string, length: number): string =>
    `${name} harus diisi ${length.toFixed()} digit angka`;

  static numbMaxDigit = (name: string, length: number): string =>
    `${name} harus diisi dan maksimal ${length.toFixed()} digit angka`;

  static numbMinDigit = (name: string, length: number): string =>
    `${name} harus diisi dan minimal ${length.toFixed()} digit angka`;

  static requiredStr = (name: string): string => {
    return `${name} harus diisi.`;
  };

  static email = (name: string) =>
    `${name} harus diisi dan dalam format yang valid.`;

  static uniqueCode = (name: string) =>
    `Harap isi ${name.toLowerCase()} dengan benar dan unik.`;

  static uniqueCodeWithMaxLength = (name: string, max: number) =>
    `${name} harus unik dan maksimal ${max} karakter.`;

  static requiredOpts = (name: string) =>
    `${name} harus dipilih dari daftar yang tersedia.`;

  static requiredDateRanges = (name: string) =>
    `${name} mulai dan akhir libur harus diisi.`;

  static options = (name: string) =>
    `${name} harus dipilih dari opsi yang tersedia.`;

  static maxChar = (
    name: string,
    max: number,
  ): [max: number, message: string] => [
    max,
    `${name} harus diisi dan maksimal ${max} karakter.`,
  ];

  static maxDigit = (name: string, max: number): string =>
    `${name} harus diisi dan maksimal ${max} digit.`;

  static maxCharWithoutSymbol = (name: string, max: number): string =>
    `${name} harus diisi dan maksimal ${max} karakter, hanya boleh mengandung huruf, angka, dan spasi.`;

  static maxCharWithoutSymbolAndSpace = (name: string, max: number): string =>
    `${name} harus diisi dan maksimal ${max} karakter, hanya boleh mengandung huruf dan angka.`;

  static enum = (name: string, opts: string): string => {
    return `${name} harus dipilih antara ${opts}`;
  };

  static minArray = (name: string, min: number): [number, string] => [
    min,
    `${name} harus diisi minimal ${min} item.`,
  ];

  static password = (name: string) =>
    `${name} minimal 8 karakter dengan kombinasi huruf, angka, dan karakter khusus.`;

  static msgFromAction = (key: string, src: any) => {
    const setRefs = typeof src == "object" ? src : {};

    if (
      !setRefs?.intent ||
      setRefs.intent != "validate" ||
      typeof setRefs.errors != "object" ||
      !setRefs.errors[key]
    )
      return undefined;

    return setRefs.errors[key];
  };
}
